import PrizeItem from "../../../views/PrizeItems";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const PrizeItems = [
  {
    menuName: MenuNames.PRIZE_ITEMS,
    path: "/prize-items",
    component: PrizeItem,
    exact: true,
  },
];

export default PrizeItems;
